import { createFileRoute, Link, Navigate } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import { isAddress } from "viem"

export const Route = createFileRoute("/trader/$address")({
	component: TraderPage,
})

/**
 * Legacy trader page - redirects to /u/{address} which handles all user profiles.
 * The /u route will further redirect to /u/{username} once the ghost user is created.
 */
function TraderPage() {
	const { address: addressParam } = Route.useParams()

	// Validate address
	const isValidAddress = isAddress(addressParam)

	// Invalid address
	if (!isValidAddress) {
		return (
			<div className="min-h-[60vh] bg-slate-50 px-4 py-16 text-slate-900 sm:px-6 lg:px-8">
				<div className="mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
					<h2 className="text-balance font-semibold text-lg">Invalid Address</h2>
					<p className="mt-2 text-pretty text-base text-slate-500">
						The address provided is not a valid Ethereum address.
					</p>
					<Link
						className="mt-6 inline-flex min-h-[44px] items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 font-semibold text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2"
						to="/"
					>
						<ArrowLeft aria-hidden="true" className="size-4" />
						Back to markets
					</Link>
				</div>
			</div>
		)
	}

	// Redirect to the unified profile page
	return <Navigate params={{ identifier: addressParam }} replace to="/u/$identifier" />
}
